import { Hotel_CloseTo as closeto, 
    Hotel_List as hotelList,
    Hotel_Hotel as hotel } from "./backend"


const getHotel = async (slug) => {
    let { data } = await hotel({
        slug: slug
    });
    return data;
}

const getHotelList = async (page, pageSize) => {
    let { data } = await hotelList({
        page: page,
        pageSize: pageSize
    });
    return data;
}

const getHotelsInRadius = async (lat, lon, rad) => {
    let { data } = await closeto({
        latitude: lat,
        longitude: lon, 
        radius: rad
    });
    return data;
}

export default {
    getHotel,
    getHotelList,
    getHotelsInRadius
}